var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Elements",
    transform: "translate(-771.000000, -871.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(771.000000, 858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#969696",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4086387,16.4991474 L21.7044873,12.2126801 C22.0962309,11.8208808 22.0962309,11.1856487 21.7044873,10.7938494 C21.3127437,10.4020502 20.6776018,10.4020502 20.2858582,10.7938494 L16,15.0903085 L11.7141418,10.7938494 C11.3223982,10.4020502 10.6872563,10.4020502 10.2955128,10.7938495 C9.90376916,11.1856487 9.90376916,11.8208808 10.2955127,12.2126801 L14.5913613,16.4991474 L10.2955127,20.7856146 C10.1063829,20.9732266 10,21.228612 10,21.4950299 C10,21.7614479 10.1063829,22.0168333 10.2955127,22.2044453 C10.4830981,22.393602 10.7384472,22.5 11.0048273,22.5 C11.2712074,22.5 11.5265565,22.393602 11.7141418,22.2044453 L16,17.9079862 L20.2858582,22.2044453 C20.4734435,22.393602 20.7287926,22.5 20.9951727,22.5 C21.2615528,22.5 21.5169019,22.393602 21.7044873,22.2044453 C21.8936171,22.0168333 22,21.7614479 22,21.4950299 C22,21.228612 21.8936171,20.9732266 21.7044873,20.7856146 L17.4086387,16.4991474 Z",
    id: "Path",
    fill: "#7C7C7C",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.7fc39a219bed9a815de8f0ef4c818a44.svg";
export { ForwardRef as ReactComponent };